import { isProxy, toRaw } from "vue";

export function collectTransferables(root: any): any[] {
    const transfers: any[] = [];

    function visit(val: any) {
        if (val == null) return;
        if (val instanceof ArrayBuffer) {
            transfers.push(val);
            return;
        }
        if (Array.isArray(val)) {
            for (const it of val) visit(it);
            return;
        }
        if (ArrayBuffer.isView(val)) {
            transfers.push(val.buffer);
            return;
        }
        if (typeof val === "object") {
            for (const k in val) visit((val as any)[k]);
        }
    }

    visit(root);
    return Array.from(new Set(transfers));
}

export function deproxy(val: any): any {
    return isProxy(val) ? toRaw(val) : val;
}


